class CollectionFiftyFifty extends window.BAO.CustomElement {
  setupListeners () {
    super.setupListeners()

    // Preload images after page load
    window.addEventListener('load', this.preloadImages.bind(this))

    if (this.els.thumbnail?.exists) {
      this.els.thumbnail.elements.forEach(thumbnail => {
        thumbnail.addEventListener('click', this.onThumbnailClick.bind(this))
      })
    }

    if (this.els.tab?.exists) {
      this.els.tab.elements.forEach(tab => {
        tab.addEventListener('click', this.onTabClick.bind(this))
      })
    }
  }

  preloadImages () {
    if (this.els.thumbnail?.exists) {
      this.els.thumbnail.elements.forEach(thumbnail => {
        const imageUrl = thumbnail.dataset.imageUrl
        if (imageUrl) {
          const img = new Image()
          img.src = imageUrl // Preload image
        }

        // Preload desktop and mobile feature images
        const desktopFeatureImageUrl = thumbnail.dataset.desktopFeatureImage
        if (desktopFeatureImageUrl) {
          const imgDesktop = new Image()
          imgDesktop.src = desktopFeatureImageUrl
        }

        const mobileFeatureImageUrl =
          thumbnail.dataset.mobileFeatureImage || desktopFeatureImageUrl
        if (mobileFeatureImageUrl) {
          const imgMobile = new Image()
          imgMobile.src = mobileFeatureImageUrl
        }
      })
    }
  }

  updateImage (imageElement, imageUrl) {
    const newImage = document.createElement('img')
    newImage.className = imageElement.className
    newImage.src = imageUrl
    newImage.srcset = imageUrl
    newImage.loading = 'eager'
    newImage.sizes = imageElement.getAttribute('sizes')
    newImage.width = imageElement.getAttribute('width')
    newImage.height = imageElement.getAttribute('height')

    // Use a smooth fade-in transition
    // newImage.style.opacity = '0'
    // newImage.style.transition = 'opacity 0.3s ease'

    // Replace the image element
    imageElement.parentNode.replaceChild(newImage, imageElement)

    // After the new image is added to the DOM, fade it in
    // requestAnimationFrame(() => {
    //   newImage.style.opacity = '1'
    // })
  }

  onThumbnailClick (e) {
    // Get the parent element
    const parent = e.currentTarget.closest(
      '[data-collection-fiftyfifty-el="body"]'
    )
    const thumbnails = parent.querySelectorAll(
      '[data-collection-fiftyfifty-el="thumbnail"]'
    )
    const currentImageLinkElement = parent.querySelector(
      '[data-collection-fiftyfifty-el="current_image"]'
    )
    const currentImageElement = parent.querySelector(
      '[data-collection-fiftyfifty-el="current_image"] img'
    )
    const currentKicker = parent.querySelector(
      '[data-collection-fiftyfifty-el="current_kicker"]'
    )
    const currentTitle = parent.querySelector(
      '[data-collection-fiftyfifty-el="current_title"]'
    )
    const currentButton = parent.querySelector(
      '[data-collection-fiftyfifty-el="current_button"]'
    )

    // Deselect all thumbnails
    thumbnails.forEach(thumbnail => {
      thumbnail.setAttribute('aria-selected', 'false')
    })

    // Select the clicked thumbnail
    const selectedThumbnail = e.currentTarget
    selectedThumbnail.setAttribute('aria-selected', 'true')

    // Update current image
    const imageUrl = selectedThumbnail.dataset.imageUrl
    if (currentImageElement && imageUrl) {
      this.updateImage(currentImageElement, imageUrl)
    }

    const productUrl = selectedThumbnail.dataset.productUrl
    if (currentImageLinkElement && productUrl) {
      currentImageLinkElement.href = productUrl
    }

    // Update the kicker, title, and button
    currentKicker.innerHTML = selectedThumbnail.dataset.kicker
    currentTitle.innerHTML = selectedThumbnail.dataset.title
    currentButton.href = selectedThumbnail.dataset.buttonUrl
    currentButton.innerHTML = selectedThumbnail.dataset.buttonText
  }

  onTabClick (e) {
    // Deselect all tabs and bodies
    this.els.tab.elements.forEach(tab => {
      tab.setAttribute('aria-selected', 'false')
    })

    this.els.body.elements.forEach(body => {
      body.setAttribute('aria-selected', 'false')
    })

    // Select the clicked tab
    const selectedTab = e.currentTarget
    selectedTab.setAttribute('aria-selected', 'true')

    // Get the data-tab attribute of the clicked tab
    const tabIndex = selectedTab.dataset.tab

    // Find and select the corresponding body element
    const correspondingBody = this.els.body.elements.find(
      body => body.dataset.tab === tabIndex
    )
    if (correspondingBody) {
      correspondingBody.setAttribute('aria-selected', 'true')

      // Get the first thumbnail in the corresponding body
      const firstThumbnail = correspondingBody.querySelector(
        '[data-collection-fiftyfifty-el="thumbnail"]'
      )
      if (firstThumbnail) {
        // Update desktop and mobile feature images
        const desktopFeatureImageUrl =
          firstThumbnail.dataset.desktopFeatureImage
        const mobileFeatureImageUrl =
          firstThumbnail.dataset.mobileFeatureImage || desktopFeatureImageUrl

        const desktopFeatureImageElement = this.els.desktop_feature_image?.element.querySelector(
          'img'
        )
        if (desktopFeatureImageElement && desktopFeatureImageUrl) {
          this.updateImage(desktopFeatureImageElement, desktopFeatureImageUrl)
        }

        const mobileFeatureImageElement = this.els.mobile_feature_image?.element.querySelector(
          'img'
        )
        if (mobileFeatureImageElement && mobileFeatureImageUrl) {
          this.updateImage(mobileFeatureImageElement, mobileFeatureImageUrl)
        }

        // Optionally, update the current image and other elements based on the first thumbnail
        // You can call the onThumbnailClick method directly
        this.onThumbnailClick({
          currentTarget: firstThumbnail,
          preventDefault: () => {},
        })
      }
    }
  }
}

if (!customElements.get('collection-fiftyfifty')) {
  customElements.define('collection-fiftyfifty', CollectionFiftyFifty)
}
